import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  customerCards: [],
  allCustomerCards: [],
  cardsByElevator: [],
  cardById: null,
  cardsLoading: false,
  cardsError: '',
  customersCardsPage: 1,
  customersCardsTotalPages: 1,
  overUsedCards: [],
  overUsedCardsLoading: false,
  overUsedCardsPages: 1,
  overUsedCardsTotalPages: 1,
};

const cardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case AC.GET_CUSTOMER_CARDS_REQUEST:
    case AC.GET_CARD_DETAILS_REQUEST:
    case AC.ADD_CARD_REQUEST:
    case AC.EDIT_CARD_REQUEST:
    case AC.DELETE_CARD_REQUEST:
    case AC.GET_ALL_CUSTOMER_CARDS_REQUEST:
    case AC.ASSIGN_CARDS_REQUEST:
    case AC.GET_CARDS_BY_ELEVATOR_REQUEST:
      return updateObject(state, {cardsLoading: true, cardsError: ''});
    case AC.GET_FREQUENTLY_USED_CARDS_REQUEST:
      return updateObject(state, {overUsedCardsLoading: true});
    case AC.GET_FREQUENTLY_USED_CARDS_SUCCEED:
      return updateObject(state, {
        overUsedCards: action.payload,
        overUsedCardsPages: action.page,
        overUsedCardsTotalPages: action.totalPages,
        overUsedCardsLoading: false,
      });
    case AC.GET_FREQUENTLY_USED_CARDS_FAILED:
      return updateObject(state, {overUsedCardsLoading: false});
    case AC.REMOVE_CARDS_BY_ELEVATOR:
      return updateObject(state, {cardsByElevator: []});
    case AC.GET_CUSTOMER_CARDS_SUCCEED:
      return updateObject(state, {
        customerCards: action.payload,
        customersCardsPage: action.page,
        customersCardsTotalPages: action.totalPages,
        cardsLoading: false,
      });
    case AC.GET_ALL_CUSTOMER_CARDS_SUCCEED:
      return updateObject(state, {
        allCustomerCards: action.payload,
        cardsLoading: false,
      });
    case AC.GET_CARD_DETAILS_SUCCEED:
      return updateObject(state, {
        cardById: action.payload,
        cardsLoading: false,
      });
      case AC.ADD_CARD_SUCCEED:
        return updateObject(state, {
          customerCards: action.payload.cards,
          cardsLoading: false,
          cardsError: '', 
        });
    case AC.GET_CARDS_BY_ELEVATOR_SUCCEED:
      return updateObject(state, {
        cardsByElevator: action.payload,
        cardsLoading: false,
      });
    case AC.GET_CUSTOMER_CARDS_FAILED:
    case AC.GET_CARD_DETAILS_FAILED:
    case AC.ADD_CARD_FAILED:
      return updateObject(state, {
        cardsError: action.payload,
        cardsLoading: false,
      });
    case AC.EDIT_CARD_FAILED:
    case AC.DELETE_CARD_FAILED:
    case AC.GET_ALL_CUSTOMER_CARDS_FAILED:
    case AC.ASSIGN_CARDS_FAILED:
    case AC.ASSIGN_CARDS_SUCCEED:
    case AC.GET_CARDS_BY_ELEVATOR_FAILED:
      return updateObject(state, {
        cardsError: action.payload,
        cardsLoading: false,
      });
    default:
      return state;
  }
};

export default cardsReducer;
